function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "13",
  viewBox: "0 0 20 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.89 4.881l.992-1.94s.6-1.232.993-1.232c.394 0 1.003 1.233 1.003 1.233l1.002 1.94m1.748 6.337h4.618M14.013 4.881l.993-1.94s.582-1.195.993-1.195c.41 0 1.002 1.196 1.002 1.196l1.003 1.94",
  stroke: "#fff",
  strokeWidth: "2.5",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
})));